"use strict";
var ApiAcknowledgement = (function () {
    function ApiAcknowledgement() {
    }
    return ApiAcknowledgement;
}());
exports.ApiAcknowledgement = ApiAcknowledgement;
//# sourceMappingURL=D:/a/1/s/base/src/models/api-acknowledgement.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/models/api-acknowledgement.model.js